import React, { useRef, useEffect } from "react";
import { Bold, Italic, Underline, List, ListOrdered, Link2, Eraser } from "lucide-react";
import "./hotelInventory.css";

const exec = (cmd, val) => document.execCommand(cmd, false, val);

const RichText = ({ value, onChange, placeholder }) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (el && document.activeElement !== el && el.innerHTML !== (value || "")) {
      el.innerHTML = value || "";
    }
  }, [value]);

  const emit = () => { if (ref.current) onChange(ref.current.innerHTML); };

  const run = (cmd, val) => {
    ref.current?.focus();
    exec(cmd, val);
    emit();
  };

  const addLink = () => {
    const url = window.prompt("Link URL (https://…)");
    if (url) run("createLink", url.trim());
  };

  const onPaste = (e) => {
    e.preventDefault();
    const text = (e.clipboardData || window.clipboardData).getData("text/plain");
    exec("insertText", text);
    emit();
  };

  const keep = (e) => e.preventDefault();

  return (
    <div className="hi-rt">
      <div className="hi-rt-bar">
        <button type="button" className="hi-rt-btn" onMouseDown={keep} onClick={() => run("bold")} title="Bold"><Bold size={15} /></button>
        <button type="button" className="hi-rt-btn" onMouseDown={keep} onClick={() => run("italic")} title="Italic"><Italic size={15} /></button>
        <button type="button" className="hi-rt-btn" onMouseDown={keep} onClick={() => run("underline")} title="Underline"><Underline size={15} /></button>
        <span className="hi-rt-sep" />
        <button type="button" className="hi-rt-btn" onMouseDown={keep} onClick={() => run("insertUnorderedList")} title="Bullet list"><List size={15} /></button>
        <button type="button" className="hi-rt-btn" onMouseDown={keep} onClick={() => run("insertOrderedList")} title="Numbered list"><ListOrdered size={15} /></button>
        <span className="hi-rt-sep" />
        <button type="button" className="hi-rt-btn" onMouseDown={keep} onClick={addLink} title="Add link"><Link2 size={15} /></button>
        <button type="button" className="hi-rt-btn" onMouseDown={keep} onClick={() => run("removeFormat")} title="Clear formatting"><Eraser size={15} /></button>
      </div>
      <div
        ref={ref}
        className="hi-rt-area"
        contentEditable
        suppressContentEditableWarning
        data-ph={placeholder || ""}
        onInput={emit}
        onBlur={emit}
        onPaste={onPaste}
      />
    </div>
  );
};

export default RichText;
